<template>
	<div>
		<div id="world-map" class="world-map">
			<world-map />
		</div>
		<div class="quotes-clients">
			<quotes />
		</div>
	</div>
</template>

<script>
	import WorldMap from './WorldMap.vue';
	import Quotes from './Quotes.vue';
	export default {
		components: {
			WorldMap,
			Quotes
		}
	}
</script>

<style lang="scss" scoped>
    @import "./../../sass/variables";
</style>
